package com.islamicmedia.shared.data.auth

import io.github.jan.supabase.SupabaseClient

/** The web has no native sheet — it is the browser redirect, and always was. */
actual suspend fun platformSignInWithGoogle(client: SupabaseClient, redirectUrl: String?) {
    browserSignInWithGoogle(client, redirectUrl)
}
